<app-dialog
  #dialog
  [key]="'create-edit-group-modal'"
  [action]="'create-edit-group-modal'"
  [headerTheme]="'simple'"
  [title]="dialogTitle"
  [maxWidth]="'520px'"
  (onClose)="form.reset()">
  <div class="p-4">
    <form [formGroup]="form" appAutoFormGroup class="row g-3">
      <div class="col-12">
        <app-input
          [controlName]="'name'"
          [label]="'Nome*'"
          [placeholder]="'Ex.: Grupo Holding ABC'" />
      </div>

      <div class="col-12">
        <app-input
          [controlName]="'description'"
          [label]="'Descrição'"
          [placeholder]="'Descrição opcional do grupo'" />
      </div>

      <!-- Setor padronizado do grupo (card 3642): próprio do grupo, não vem das empresas. -->
      <div class="col-12" *appHasPermission="companySectorPermissions.LIST">
        <app-company-sector-field [form]="form" [controlName]="'companySectorId'" />
      </div>
    </form>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        [loadingText]="'Salvando...'"
        [label]="isEditMode ? 'Salvar alterações' : 'Criar grupo'"
        (sendButtonClick)="submitAction()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
